<template>
  <!--aside-->
    <div class="aside">
    </div>
    <!--e aside-->
</template>

<script>
export default {
  name: 'MenuBar',
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MenuBar.vue